import * as React from 'react';
import { Form, CustomSubmitButton, CustomSubmitButtonType } from "soprasteria-ui-library";
import { CareProviderDropdown } from '../../CareProviderDropdown/CareProviderDropdown';
import { ICareProvider } from '../../../models/ICareProvider';
import { useAuth } from '../../../App';
import { PreventionProgramApi } from '../../../api/PreventionProgramApi';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileExcel } from '@fortawesome/free-solid-svg-icons';
import { formatDate } from '../../../helpers/DateHelper';
import { IPreventionProgramPatientSearchParams } from '../../../models/IPreventionProgramPatient';
import { isInRole, UserContext } from '../../../contexts/UserContext';
import { VÅRDANSVARIG, LIBRETTOADMIN } from '../../../utils/RoleConstants';

interface IPreventionProgramInfantsForm {
    getPreventionProgramPatients: (searchParams: IPreventionProgramPatientSearchParams) => void;
}

export const PreventionProgramInfantsForm: React.FunctionComponent<IPreventionProgramInfantsForm> = ({ getPreventionProgramPatients }) => {
    const userInfo = React.useContext(UserContext);
    const hasRoleParaply = isInRole(VÅRDANSVARIG, userInfo.roles);
    const hasRoleSystemAdmin = isInRole(LIBRETTOADMIN, userInfo.roles);
    const auth = useAuth();
    const api = new PreventionProgramApi(auth);
    const [careProviders, setCareProviders] = React.useState<ICareProvider[]>();
    const [isExportingToExcel, setIsExportingToExcel] = React.useState<boolean>(false);

    React.useEffect(() => {
        if (userInfo) {
            if (hasRoleParaply || hasRoleSystemAdmin) {
                getCareProviders();
            }
            else {
                getPreventionProgramPatients({ pageSize: 20, pageNumber: 1 })
            }
        }
    }, [userInfo])

    React.useEffect(() => {
        if (careProviders) {
            getPreventionProgramPatients({ pageSize: 20, pageNumber: 1, careProviderId: careProviders[0].careProviderId })
        }
    }, [careProviders])

    const getCareProviders = () => {
        api.getPreventionProgramCareProviders((data) => { setCareProviders(data) });
    }

    const exportPrevetionProgramPatientsToExcel = (params: IPreventionProgramPatientSearchParams) => {
        setIsExportingToExcel(true);
        api.getPreventionProgramInfantsAsExcel(params,
            `0-2 åringar i kariespreventionsprogrammet ${formatDate()}`,
            () => { },
            () => { },
            () => {
                setIsExportingToExcel(false);
            }
        );
    }

    return (
        <section>
            <Form>
                {
                    hasRoleParaply || hasRoleSystemAdmin ?
                        <div className="col-6">
                            <CareProviderDropdown name="careProviderId" showClinicId careProviders={careProviders} isLoading={careProviders === undefined} defaultValue={careProviders ? careProviders[0].careProviderId.toString() : undefined} />
                        </div>
                        : null
                }
                <div className="text-right panel">
                    <span className="d-none">
                        <CustomSubmitButton onButtonSubmit={getPreventionProgramPatients}>Sök</CustomSubmitButton>
                    </span>
                    <CustomSubmitButton buttonType={CustomSubmitButtonType.alternative} isLoading={isExportingToExcel} onButtonSubmit={exportPrevetionProgramPatientsToExcel}><FontAwesomeIcon icon={faFileExcel} /> Exportera till Excel</CustomSubmitButton>
                    {
                        hasRoleParaply || hasRoleSystemAdmin ?
                            <CustomSubmitButton onButtonSubmit={getPreventionProgramPatients}>Sök</CustomSubmitButton>
                            : null
                    }
                </div>
            </Form>
        </section>
    )
}